export const enum ModalSEEnum {
  HOME = 'home',
  AUTOAVALIACAO = 'autoavaliacao'
}
